import { render } from "./libur-list.vue?vue&type=template&id=c37a27d2"
import script from "./libur-list.vue?vue&type=script&lang=js"
export * from "./libur-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__